import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { createElement } from "@wordpress/element";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * External dependencies
 */
import moment from 'moment'; // react-dates doesn't tree-shake correctly, so we import from the individual
// component here, to avoid including too much of the library

import DayPickerSingleDateController from 'react-dates/lib/components/DayPickerSingleDateController';
/**
 * WordPress dependencies
 */

import { Component, createRef } from '@wordpress/element';
import { isRTL } from '@wordpress/i18n';
/**
 * Module Constants
 */

var TIMEZONELESS_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

var DatePicker = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.apply(this, arguments);
    _this.onChangeMoment = _this.onChangeMoment.bind(_assertThisInitialized(_this));
    _this.nodeRef = createRef();
    _this.keepFocusInside = _this.keepFocusInside.bind(_assertThisInitialized(_this));
    _this.isDayHighlighted = _this.isDayHighlighted.bind(_assertThisInitialized(_this));
    return _this;
  }
  /*
   * Todo: We should remove this function ASAP.
   * It is kept because focus is lost when we click on the previous and next month buttons.
   * This focus loss closes the date picker popover.
   * Ideally we should add an upstream commit on react-dates to fix this issue.
   */


  _createClass(DatePicker, [{
    key: "keepFocusInside",
    value: function keepFocusInside() {
      if (!this.nodeRef.current) {
        return;
      }

      var ownerDocument = this.nodeRef.current.ownerDocument;
      var activeElement = ownerDocument.activeElement; // If focus was lost.

      if (!activeElement || !this.nodeRef.current.contains(ownerDocument.activeElement)) {
        // Retrieve the focus region div.
        var focusRegion = this.nodeRef.current.querySelector('.DayPicker_focusRegion');

        if (!focusRegion) {
          return;
        } // Keep the focus on focus region.


        focusRegion.focus();
      }
    }
  }, {
    key: "onChangeMoment",
    value: function onChangeMoment(newDate) {
      var _this$props = this.props,
          currentDate = _this$props.currentDate,
          onChange = _this$props.onChange; // If currentDate is null, use now as momentTime to designate hours, minutes, seconds.

      var momentDate = currentDate ? moment(currentDate) : moment();
      var momentTime = {
        hours: momentDate.hours(),
        minutes: momentDate.minutes(),
        seconds: 0
      };
      onChange(newDate.set(momentTime).format(TIMEZONELESS_FORMAT));
    }
    /**
     * Create a Moment object from a date string. With no currentDate supplied, default to a Moment
     * object representing now. If a null value is passed, return a null value.
     *
     * @param {?string} currentDate Date representing the currently selected date or null to signify no selection.
     * @return {?moment.Moment} Moment object for selected date or null.
     */

  }, {
    key: "getMomentDate",
    value: function getMomentDate(currentDate) {
      if (null === currentDate) {
        return null;
      }

      return currentDate ? moment(currentDate) : moment();
    } // todo change reference to `isDayHighlighted` every time, `events` prop change

  }, {
    key: "isDayHighlighted",
    value: function isDayHighlighted(date) {
      var _this$props$events;

      // Do not highlight when no events.
      if (!((_this$props$events = this.props.events) !== null && _this$props$events !== void 0 && _this$props$events.length)) {
        return false;
      }

      if (this.props.onMonthPreviewed) {
        this.props.onMonthPreviewed(date.toDate());
      } // Compare date against highlighted events.


      return this.props.events.some(function (highlighted) {
        return date.isSame(highlighted.date, 'day');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentDate = _this$props2.currentDate,
          isInvalidDate = _this$props2.isInvalidDate;
      var momentDate = this.getMomentDate(currentDate);
      return createElement("div", {
        className: "components-datetime__date",
        ref: this.nodeRef
      }, createElement(DayPickerSingleDateController, {
        date: momentDate,
        daySize: 30,
        focused: true,
        hideKeyboardShortcutsPanel: true // This is a hack to force the calendar to update on month or year change
        // https://github.com/airbnb/react-dates/issues/240#issuecomment-361776665
        ,
        key: "datepicker-controller-".concat(momentDate ? momentDate.format('MM-YYYY') : 'null'),
        noBorder: true,
        numberOfMonths: 1,
        onDateChange: this.onChangeMoment,
        transitionDuration: 0,
        weekDayFormat: "ddd",
        isRTL: isRTL(),
        isOutsideRange: function isOutsideRange(date) {
          return isInvalidDate && isInvalidDate(date.toDate());
        },
        isDayHighlighted: this.isDayHighlighted,
        onPrevMonthClick: this.keepFocusInside,
        onNextMonthClick: this.keepFocusInside
      }));
    }
  }]);

  return DatePicker;
}(Component);

export default DatePicker;
//# sourceMappingURL=date.js.map